import { useEffect, useState } from 'react';

const useViewportSize = () => {
  const [viewportSize, setViewportSize] = useState(window.innerWidth);

  const handleWindowResize = () => {
    setViewportSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return viewportSize;
};

export default useViewportSize;
